module.exports = __webpack_public_path__ + "img/uvradiation_icon.713986b3.svg";